import React from "react";

const Hammer = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_44_3701)">
      <path
        d="M23.929 10.9064L16.8594 3.83582L8.37298 12.321L15.4426 19.3916L23.929 10.9064Z"
        fill="#76B900"
      />
      <path
        d="M27.4638 8.778L18.9788 0.294003C18.5878 -0.097997 17.9558 -0.097997 17.5648 0.293003L16.1498 1.708C15.7578 2.099 15.7568 2.731 16.1498 3.123L24.6338 11.607C25.0248 11.999 25.6568 11.999 26.0488 11.608L27.4628 10.192C27.8538 9.802 27.8538 9.17 27.4638 8.778Z"
        fill="#434854"
      />
      <path
        d="M7.66534 11.6064C7.27434 11.2144 6.64234 11.2144 6.25134 11.6064L4.83734 13.0204C4.44534 13.4124 4.44434 14.0434 4.83734 14.4354L13.3213 22.9204C13.7123 23.3114 14.3443 23.3114 14.7363 22.9204L16.1503 21.5054C16.5413 21.1144 16.5403 20.4824 16.1503 20.0914L7.66534 11.6064Z"
        fill="#434854"
      />
      <path
        d="M29.5829 22.2116L21.0977 13.7264L18.2707 16.5534L26.7559 25.0386L29.5829 22.2116Z"
        fill="#434854"
      />
      <path
        d="M28.8802 27.1573C28.4892 27.5483 27.8572 27.5483 27.4662 27.1573L26.7592 26.4503C26.3672 26.0593 26.3662 25.4273 26.7592 25.0353L29.5862 22.2083C29.9782 21.8153 30.6102 21.8163 31.0012 22.2083L31.7082 22.9153C32.0992 23.3063 32.0992 23.9383 31.7082 24.3293L28.8802 27.1573Z"
        fill="#76B900"
      />
      <path
        opacity="0.3"
        d="M21.8048 14.4335L21.0977 13.7264L18.2707 16.5534L18.9778 17.2605L21.8048 14.4335Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M23.929 10.9064L16.8594 3.83582L16.1529 4.54221L23.2225 11.6128L23.929 10.9064Z"
        fill="black"
      />
      <path
        opacity="0.15"
        d="M23.9257 10.899L21.0977 8.07019L12.612 16.5535L15.44 19.3823L23.9257 10.899Z"
        fill="black"
      />
      <g opacity="0.1">
        <path
          opacity="0.1"
          d="M26.0516 11.6032L27.4656 10.1872C27.8566 9.79619 27.8566 9.16519 27.4656 8.77319L24.6376 5.94519L21.8086 8.77419L24.6366 11.6022C25.0266 11.9942 25.6596 11.9942 26.0516 11.6032Z"
          fill="black"
        />
        <path
          opacity="0.1"
          d="M16.1541 20.0867L13.3251 17.2577L10.4961 20.0877L13.3251 22.9157C13.7161 23.3067 14.3481 23.3067 14.7391 22.9167L16.1541 21.5007C16.5451 21.1097 16.5441 20.4777 16.1541 20.0867Z"
          fill="black"
        />
      </g>
      <path
        d="M21 29V27C21 26.447 20.553 26 20 26H2C1.447 26 1 26.447 1 27V29C0.447 29 0 29.447 0 30V32H22V30C22 29.447 21.553 29 21 29Z"
        fill="#434854"
      />
      <path opacity="0.3" d="M21 28H1V29H21V28Z" fill="black" />
    </g>
    <defs>
      <clipPath id="clip0_44_3701">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Hammer;
